// extracted by mini-css-extract-plugin
module.exports = {"content":"tag-m__content__2m_es","no-stories":"tag-m__no-stories__4myX5","en-no-stories":"tag-m__en-no-stories__1N-Uy"};